import React from 'react'
import { Button } from 'antd'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { FilePdfOutlined } from '@ant-design/icons'

function Pdf(props) {
  const { formatMessage } = useIntl()
  const title = props.title === 'button.pdf' ? formatMessage({ id: props.title }) : props.title
  return (
    <Button {...props} title={title}>
      {title}
    </Button>
  )
}

Pdf.propTypes = {
  type: PropTypes.string,
  icon: PropTypes.object,
  title: PropTypes.string,
  id: PropTypes.string,
  onClick: PropTypes.func,
}

Pdf.defaultProps = {
  type: 'default',
  icon: <FilePdfOutlined />,
  title: 'button.pdf',
  onClick: () => {},
  id: 'btn-pdf',
}

export default Pdf
